export default {
      id: "pause-usage",
      viewBox: "0 0 8 9",
      url: __webpack_public_path__ + "sprite-46b249.svg#pause-usage",
      toString: function () {
        return this.url;
      }
    }